import { useQuery } from '@tanstack/react-query';
import { readContract } from '@wagmi/core';

import { wagmiConfig } from '@shared/common/providers/Web3Provider/wagmi';
import { DEFAULT_TARGET_CHAIN } from '@shared/constants';
import { ParsedWeiAmount, parseWei } from '@shared/helpers/web3/formatters';

import { PREDICTIONS_CONTRACT } from '../config/contract';
import { getQueryKey } from '../config/query';

const DEFAULT_MIN_AVAILABLE_BET = 0;

const fetchMinBetAmount = async (): Promise<ParsedWeiAmount> => {
  try {
    const minBetAmount = await readContract(wagmiConfig, {
      ...PREDICTIONS_CONTRACT,
      chainId: DEFAULT_TARGET_CHAIN.id,
      functionName: 'minBetAmount',
      args: [],
    });

    return parseWei({
      wei: minBetAmount,
      tokenName: 'USDT',
      formatOptions: {
        stableToDollar: false,
      },
    });
  } catch (error) {
    console.error(error);
    return {
      wei: BigInt(DEFAULT_MIN_AVAILABLE_BET),
      value: DEFAULT_MIN_AVAILABLE_BET,
      formatted: '',
    };
  }
};

export const useMinBetAmount = () =>
  useQuery({
    queryKey: getQueryKey('min-bet-amount'),
    queryFn: fetchMinBetAmount,
  });
